"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5600],{

/***/ 75600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionTechstackSlider": function() { return /* binding */ SectionTechstackSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79570);
/* harmony import */ var _portfolio_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55022);
/* harmony import */ var _portfolio_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75762);



const StyledSectionWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .SectionWrapper */ .Uq, {
    margin: "$mobileSectionMarginL 0",
    backgroundColor: "$darkThemeBackground",
    color: "$white",
    "@md": {
        margin: "$desktopSectionMarginL 0"
    }
});
const Content = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gap: "$36",
    margin: "0 auto",
    containerSpace: "medium",
    width: "100%"
});
const Title = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("h2", {
    projectFont: "heading02",
    textAlign: "center",
    padding: "0 $20",
    marginBottom: "$96",
    "@lg": {
        marginBottom: "$120"
    }
});
const CardWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    padding: "$24",
    backgroundColor: "$techstackCardsBackground",
    borderRadius: "$r3",
    maxWidth: "500px",
    width: "100%",
    margin: "0 auto",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    gap: "$48",
    "@lg": {
        padding: "$32",
        gap: "$64"
    }
});
const UpperContent = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gridAutoFlow: "row",
    gap: "$24",
    "@lg": {
        gap: "$32"
    }
});
const Description = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    projectFont: "heading08",
    color: "$white_07",
    maxWidth: "360px"
});
const LogoWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    variants: {
        size: {
            small: {
                width: "110px",
                minHeight: "30px"
            },
            big: {
                width: "120px",
                height: "auto"
            }
        }
    }
});
const ImageWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    borderRadius: "$r2",
    overflow: "hidden",
    width: "80px",
    height: "80px",
    "@md": {
        width: "100px",
        height: "100px"
    }
});
const QuoteBlockWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    projectFont: "body03",
    color: "$white_05",
    display: "grid",
    gap: "$20",
    gridAutoFlow: "row",
    "@md": {
        gap: "$32",
        gridTemplateColumns: "100px 1fr",
        gridTemplateRows: "1fr"
    }
});
const Quote = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {
    color: "$white"
});
const LinkBlockWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    backgroundColor: "$techstackLinkBlockBackground",
    borderRadius: "$r3_mobile",
    padding: "$16",
    display: "grid",
    gap: "$8",
    alignItems: "center",
    position: "relative",
    "&::before": {
        content: "",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        background: "linear-gradient(to left top, #1E689B, #009385)",
        borderRadius: "$r3_mobile",
        border: "1px solid transparent",
        maskComposite: "exclude",
        "-webkit-mask": "linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)",
        "-webkit-mask-composite": "destination-out;"
    },
    "@md": {
        gridAutoFlow: "column",
        gap: "$24"
    }
});
const LinkBlockContent = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    projectFont: "ui04",
    color: "$white_07",
    width: "100%",
    zIndex: 10
});
const LinkWrapper = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("span", {
    color: "$white",
    display: "inline"
});
const MobileContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gridAutoFlow: "row",
    gap: "$20",
    padding: "0 $20",
    margin: "$0 auto"
});
const Pills = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "flex",
    flexWrap: "wrap",
    listStyleType: "none",
    gap: "$8"
});
const BlockWrap = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "grid",
    gridAutoFlow: "row",
    gap: "$24",
    "& > *:last-child": {
        alignSelf: "end"
    },
    "@lg": {
        gap: "$32"
    }
});
const DesktopVisibilityContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "none",
    "@lg": {
        display: "block"
    }
});
const MobileVisibilityContainer = (0,_portfolio_styles__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    display: "block",
    "@lg": {
        display: "none"
    }
});
const QuoteBlock = (param)=>{
    let { name , quote , role , image  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(QuoteBlockWrapper, {
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                    ...image
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    quote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Quote, {
                        children: quote
                    }),
                    name && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: name
                    }),
                    role && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: role
                    })
                ]
            })
        ]
    });
};
const LinkBlock = (param)=>{
    let { logo , content , cta , ctaLabel  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(LinkBlockWrapper, {
        children: [
            (logo === null || logo === void 0 ? void 0 : logo.mediaPayload.type) === "sanity-image" && (logo === null || logo === void 0 ? void 0 : logo.mediaPayload.image.asset) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                size: "small",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                    ...logo
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkBlockContent, {
                children: content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            children: [
                                content,
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkWrapper, {
                                children: cta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                                    ...cta,
                                    children: ctaLabel
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const Card = (param)=>{
    let { _key , logo , description , elements , footerBlocks  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CardWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UpperContent, {
                children: [
                    logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrap, {
                        size: "small",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Media */ .pU, {
                            ...logo
                        })
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Description, {
                        children: description
                    }),
                    (elements === null || elements === void 0 ? void 0 : elements.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pills, {
                        children: elements === null || elements === void 0 ? void 0 : elements.map((element)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Pill */ .DR, {
                                appearance: "UI06Uppercase",
                                children: element
                            }, "".concat(_key, "-").concat(element)))
                    })
                ]
            }),
            (footerBlocks === null || footerBlocks === void 0 ? void 0 : footerBlocks.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlockWrap, {
                children: footerBlocks === null || footerBlocks === void 0 ? void 0 : footerBlocks.map((block)=>{
                    if (block._type === "linkBlock") {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkBlock, {
                            ...block
                        }, block._key);
                    }
                    if (block._type === "quoteBlock") {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuoteBlock, {
                            ...block
                        }, block._key);
                    }
                    return null;
                })
            })
        ]
    });
};
const SectionTechstackSlider = (param)=>{
    let { title , slides , spacing , topBorder  } = param;
    if (!(slides === null || slides === void 0 ? void 0 : slides.length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledSectionWrapper, {
        type: spacing || "DEFAULT",
        topBorder: topBorder,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {
                children: title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DesktopVisibilityContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_portfolio_components__WEBPACK_IMPORTED_MODULE_2__/* .Slider */ .iR, {
                    children: slides === null || slides === void 0 ? void 0 : slides.map((slide)=>{
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                            ...slide
                        }, slide === null || slide === void 0 ? void 0 : slide._key);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileVisibilityContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobileContainer, {
                    children: slides === null || slides === void 0 ? void 0 : slides.map((slide)=>{
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                            ...slide
                        }, slide === null || slide === void 0 ? void 0 : slide._key);
                    })
                })
            })
        ]
    });
};


/***/ })

}]);